import TaskListPage from './task-list-page'

export default TaskListPage
